import { UserSettings, CreditPackage } from '../types';
import { EDU_CONFIG, CREDIT_PACKAGES } from '../config';

export interface UserLimits {
    maxClasses: number;
    maxStudents: number;
    maxChildren: number;
    maxLearningPlans: number;
    /** Nhóm Bookai (credit / chia sẻ); -1 = không giới hạn */
    maxGroups: number;
}

export const getUserLimits = (user: UserSettings | null): UserLimits => {
    const defaults = {
        maxClasses: EDU_CONFIG.DEFAULT_LIMITS.MAX_CLASSES,
        maxStudents: EDU_CONFIG.DEFAULT_LIMITS.MAX_STUDENTS,
        maxChildren: EDU_CONFIG.DEFAULT_LIMITS.MAX_CHILDREN,
        maxLearningPlans: EDU_CONFIG.DEFAULT_LIMITS.MAX_LEARNING_PLANS,
        maxGroups: EDU_CONFIG.DEFAULT_LIMITS.MAX_GROUPS,
    };

    if (!user) return defaults;

    // Ưu tiên 1: Lấy từ package đã mua
    if (user.purchaseHistory && user.purchaseHistory.length > 0) {
        const lastPurchase = user.purchaseHistory[user.purchaseHistory.length - 1];
        const pkg = CREDIT_PACKAGES.find(p => p.id === lastPurchase.packageId);
        
        if (pkg) {
            return {
                maxClasses: pkg.maxClasses ?? defaults.maxClasses,
                maxStudents: pkg.maxStudents ?? defaults.maxStudents,
                maxChildren: pkg.maxChildren ?? defaults.maxChildren,
                maxLearningPlans: pkg.maxLearningPlans ?? defaults.maxLearningPlans,
                maxGroups: pkg.maxGroups ?? defaults.maxGroups,
            };
        }
    }

    // Ưu tiên 2: Lấy từ cấu hình hệ thống trả về trong userSettings (Admin Settings)
    return {
        maxClasses: (user as any).maxClasses ?? defaults.maxClasses,
        maxStudents: (user as any).maxStudents ?? defaults.maxStudents,
        maxChildren: (user as any).maxChildren ?? defaults.maxChildren,
        maxLearningPlans: (user as any).maxLearningPlans ?? defaults.maxLearningPlans,
        maxGroups: (user as any).maxGroups ?? defaults.maxGroups,
    };
};

export const checkLimit = (currentCount: number, limit: number): boolean => {
    if (limit === -1) return true; // Unlimited
    return currentCount < limit;
};
